
  import { defineComponent, PropType } from 'vue';

  import { TStatisticsPortalFilter } from '../../../types/statistics/statistics-portal';
  import StatisticsVisitsCountTabs from '../StatisticsVisitsCountTabs.vue';
  import StatisticsPortalVisitsCountByTimeTab from './StatisticsPortalVisitsCountByTimeTab.vue';
  import StatisticsPortalVisitsCountByUsers from './StatisticsPortalVisitsCountByUsers.vue';

  export default defineComponent({
    name: 'StatisticsPortalVisitsCountTabs',
    components: {
      StatisticsVisitsCountTabs,
      StatisticsPortalVisitsCountByTimeTab,
      StatisticsPortalVisitsCountByUsers,
    },
    props: {
      filter: {
        type: Object as PropType<TStatisticsPortalFilter>,
        required: true,
      },
    },
  });
